import React, {useMemo} from 'react'
import {useDispatch} from 'lib/redux'
import {useTranslation} from 'i18n'
import {GiftShopFloatingButton} from 'pages'
import {useRefresh} from '../GiftshopRefreshHooks'

export function useRefreshResend({
  lastUpdate,
  showButton = true,
  onRefresh,
}: {
  lastUpdate?: number
  showButton?: boolean
  onRefresh: () => void
}) {
  const {update} = useDispatch()
  const {translate} = useTranslation()

  const {handleRefresh, shouldRenderButton} = useRefresh({
    lastUpdate,
    onRefresh: () => {
      onRefresh()
      update('giftshopState', {
        resendRefresher: new Date(),
      })
    },
  })

  const handleRenderButton = useMemo(
    () => (
      <GiftShopFloatingButton
        title={translate('giftShop:resendFloatingButtonTitle')}
        subtitle={translate('giftShop:resendFloatingButtonSubtitle')}
        handleRefresh={handleRefresh}
        shouldRenderButton={shouldRenderButton && showButton}
      />
    ),
    [handleRefresh, shouldRenderButton, showButton, translate],
  )

  return useMemo(
    () => ({
      handleRefresh,
      handleRenderButton,
      shouldRenderButton,
    }),
    [handleRefresh, handleRenderButton, shouldRenderButton],
  )
}
